import {Modal, Select, Text} from '@mantine/core';
import type {ForwardRefExoticComponent, RefAttributes} from 'react';
import {Z_INDEX} from '../../../../constants/zIndex';
import {ModalCancelButton} from '../ModalCancelButton';
import {ModalSubmitButton} from '../ModalSubmitButton';

type ReportAnalyzeModalProps = {
  opened: boolean;
  onClose: () => void;
  onSubmit: () => void;
  departmentOptions: {
    value: string;
    label: string;
    reportType: 'selection' | 'intern';
  }[];
  selectedOption: string;
  onSelectChange: (value: string | null) => void;
  isLoading?: boolean;
  itemComponent?: ForwardRefExoticComponent<
    {
      label: string;
      value: string;
      reportType: 'selection' | 'intern';
    } & React.ComponentPropsWithoutRef<'div'> &
      RefAttributes<HTMLDivElement>
  >;
  badgeComponent?: React.ReactNode;
  companyName?: string;
};

export const ReportAnalyzeModal: React.FC<ReportAnalyzeModalProps> = ({
  opened,
  onClose,
  onSubmit,
  departmentOptions,
  selectedOption,
  onSelectChange,
  isLoading = false,
  itemComponent,
  badgeComponent,
  companyName,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      radius={16}
      centered
      size="md"
      title="体験記から選考予定を生成"
      zIndex={Z_INDEX.MODAL}
      styles={{
        title: {
          fontWeight: 'bold',
        },
      }}
    >
      <div className="flex flex-col gap-24">
        <div className="flex flex-col gap-8">
          {companyName && (
            <div className="bg-background-1 rounded-8 px-12 py-8 mb-12 text-sm text-black-1 font-bold">
              企業: {companyName}
            </div>
          )}
          <Text className="text-sm text-black-2">
            部門・職種を選択してください
          </Text>
          <Select
            placeholder="選択してください"
            data={departmentOptions}
            value={selectedOption}
            onChange={onSelectChange}
            maxDropdownHeight={300}
            itemComponent={itemComponent}
            icon={badgeComponent}
            iconWidth={80}
            disabled={isLoading}
            withinPortal
            styles={{
              input: {
                borderRadius: '12px',
              },
              dropdown: {
                cursor: isLoading ? 'not-allowed' : 'pointer',
              },
            }}
          />
        </div>

        <div className="flex items-center justify-center gap-16">
          <ModalCancelButton onClick={onClose}>キャンセル</ModalCancelButton>
          <ModalSubmitButton
            onClick={onSubmit}
            disabled={!selectedOption || isLoading}
            isLoading={isLoading}
          >
            選考予定を生成
          </ModalSubmitButton>
        </div>
      </div>
    </Modal>
  );
};
